// extracted by mini-css-extract-plugin
module.exports = {"bulkActions":"bulkActions__oqiFK","container":"container__4usB2","text":"text__BkXgg","buttons":"buttons__WAF9i"};